import React from 'react';
import SelectInput from '@/common/components/SelectInput';
import { Colors } from '@/common/colors/colors';
import { ReasoningWrapper, Textarea } from './Reasoning.styled';
import {
	SectionWrapper,
	Subtitle,
} from '@/common/components/validClaimForm/ValidClaimForm.styled';
import { CLAIM_REASONS } from '@/common/constants/support';
import { useValidClaim } from '@/common/hooks/useValidClaim';


const Reasoning = () => {

	const {
		claim,
		claimReason,
		setClaimReason,
		feedbackRef,
	} = useValidClaim();

	return (
		<SectionWrapper>
			<ReasoningWrapper>
				<div>
					<Subtitle>Claim reason</Subtitle>
					<SelectInput
						disabled={claim}
						selected={claimReason}
						setSelected={setClaimReason}
						placeholder='Select claim reason'
						showLabel={false}
						selectWidth={180}
						selectFontSize={12}
						options={CLAIM_REASONS}
						margin='0'
						minHeight='18px'
						dropdownIndicatorPadding='4px'
						placeholderColor={Colors.darkGray2}
					/>
				</div>
				<div>
					<Subtitle>Client comment</Subtitle>
					<Textarea
						disabled={claim}
						defaultValue={feedbackRef.current?.value}
						ref={feedbackRef}
						placeholder="Enter client's comment here"
					/>
				</div>
			</ReasoningWrapper>
		</SectionWrapper>
	);
};

export default Reasoning;
